import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { ValueAdapter } from '../../value.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ODataCopySource } from 'app/model/pipeline/copysource/odata.copysource';
import { stringIsNullOrEmpty } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ODataCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        httpRequestTimeout: '*'
    }
})
export class ODataCopySourceAdapter extends CopySourceAdapter<ODataCopySource, Model.ODataSource> {
    protected override async _toResource(copySource: ODataCopySource): Promise<Model.ODataSource> {
        const result: Model.ODataSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(ODataCopySource).name
        );
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, ODataCopySource.READER_QUERY);
        }
        result.httpRequestTimeout = ValueAdapter.toResource(copySource, ODataCopySource.HTTP_REQUEST_TIMEOUT);
        // clear out '' from resource, backend doesn't support ''
        if (stringIsNullOrEmpty(result.httpRequestTimeout)) {
            result.httpRequestTimeout = undefined;
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.ODataSource,
        copyActivity: CopyActivity
    ): Promise<ODataCopySource> {
        const result: ODataCopySource = this._toTabularModel(resource, copyActivity, ODataCopySource.MODEL);
        if (resource.httpRequestTimeout != null) {
            ValueAdapter.toModel(result, ODataCopySource.HTTP_REQUEST_TIMEOUT, resource.httpRequestTimeout);
        } else {
            // clear default value for all existing resources
            result.httpRequestTimeout = undefined;
        }
        return result;
    }
}
